import { atom } from "jotai";

export type TradesGroupingMode = "underlying-date" | "date-underlying";

const STORAGE_KEY = "trades-grouping-mode";

// Get initial value from localStorage
const getInitialGroupingMode = (): TradesGroupingMode => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "underlying-date" || stored === "date-underlying") {
    return stored;
  }
  return "date-underlying"; // default
};

export const TradesGroupingModeAtom = atom<TradesGroupingMode>(
  getInitialGroupingMode()
);

export const setTradesGroupingModeInStorage = (mode: TradesGroupingMode) => {
  localStorage.setItem(STORAGE_KEY, mode);
};

